// extracted by mini-css-extract-plugin
module.exports = {"socialMediaItem":"Form_socialMediaItem__2x5Zp","info_check_list":"Form_info_check_list__1-fwo","mainCountry":"Form_mainCountry__Fwqru"};